import React, { useEffect, useState } from 'react';
import { ActivityIndicator, Text, View } from 'react-native';
import { useTranslation } from '@/hooks/useTranslation';
import { mcsPrepAPI } from '@/services/api/mcsPrepAPI';
import type { McsCohortSummary } from '@/types/mcsPrep';
import { ActionButton, Panel, mentorStyles } from '@/components/mentorEngagements/shared';
export default function McsCohortSummaryPanel({ cohortId }: { cohortId: number }) {
  const { t } = useTranslation();
  const [data, setData] = useState<McsCohortSummary | null>(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true; setData(null); setError(false);
    void mcsPrepAPI.cohortSummary(cohortId).then(value => { if (active) setData(value); }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [cohortId, attempt]);
  return <Panel><Text style={mentorStyles.panelTitle}>{t('mcs.summary')}</Text>{error ? <ActionButton label={t('mcs.summaryError')} onPress={() => setAttempt(v => v + 1)} /> : !data ? <ActivityIndicator /> : data.members.length === 0 ? <Text>{t('mcs.emptySummary')}</Text> : data.members.map(member => <View key={member.user_id}><Text style={mentorStyles.bodyText}>{member.display_name}</Text><Text style={mentorStyles.mutedText}>{t('mcs.statuses.done')}: {member.checklist_counts.done} · {t('mcs.statuses.todo')}: {member.checklist_counts.todo} · {t('mcs.statuses.needs_attention')}: {member.checklist_counts.needs_attention}</Text></View>)}</Panel>;
}
